<template>
  <div v-if="titleBottomInfo && titleBottomInfo.length" class="deliver-wrap">
    <new-common-banner
      v-if="topList.length && !bottomList.length"
      v-zpm="{ sectionid: 127, sortname: '活动', sortid: 0, other: '活动' }"
      :icon="icon"
      @ensureClick="listenTopClick"
    >
      <div class="process-item">
        <div class="item_address">
          <span class="title">活动</span>
          <span class="title_info">{{ topList[0].title }}</span>
        </div>
        <div class="item_info">
          {{ topList[0].content }}
        </div>
      </div>
    </new-common-banner>
    <mulite-common-line
      v-else
      v-zpm="{ sectionid: 127, sortname: '活动', sortid: 0, other: '活动' }"
      :icon="icon"
      :showBottomArrow="Boolean(bottomList.length)"
      @listenTopClick="listenTopClick"
      @listenBottomClick="togglePopup"
    >
      <template v-if="topList.length" #contentTop>
        <div class="process-item">
          <div class="item_address">
            <span class="title">活动</span>
            <span class="title_info">{{ topList[0].title }} , {{ topList[0].content }}</span>
          </div>
        </div>
      </template>

      <template v-if="bottomList.length" #contentBottem>
        <div class="process-item bottom-item">
          <div class="item_address">
            <span v-for="(item, index) in bottomList" :key="index" class="info_text">{{
              item.title
            }}</span>
          </div>
        </div>
      </template>
    </mulite-common-line>

    <z-action-picker
      v-model="showCondition"
      title="活动"
      show-btn
      btn-text="我知道了"
      height="50vh"
      class="product-detail-popup"
      @confirm="togglePopup"
    >
      <div class="params-content">
        <div class="content-list">
          <div
            v-for="(item, index) in titleBottomInfoList"
            :key="index"
            class="item-content"
            @click="popupClick(item)"
          >
            <div class="item-content-info">
              <div class="info-title">{{ item.title }}</div>
              <div class="info-desc">{{ item.content }}</div>
            </div>
            <img
              :src="
                $setPicSize(
                  'https://pic6.zhuanstatic.com/zhuanzh/ba948031-11ee-41a9-a176-2acc5029456d.png'
                )
              "
              class="icon_arrow"
              alt=""
            />
          </div>
        </div>
      </div>
    </z-action-picker>
  </div>
</template>

<script>
import Vue from 'vue'
import { defineComponent, ref, computed } from '@vue/composition-api'
import muliteCommonLine from '@/components/mulite-common-line.vue'
import newCommonBanner from '@/components/new-common-banner.vue'
import { skipToUrl } from '@utils/native'
import { ActionPicker } from '@zz-common/zz-ui'
Vue.use(ActionPicker)
export default defineComponent({
  components: {
    newCommonBanner,
    muliteCommonLine
  },
  props: {
    titleBottomInfo: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const icon = ref(
      'https://pic4.zhuanstatic.com/zhuanzh/85e947ee-798c-40cf-a897-dd73fd08af4a.png'
    )

    const showCondition = ref(false)

    /**
     * $ 活动列表
     */
    const titleBottomInfoList = computed(() => {
      return props.titleBottomInfo || []
    })

    /**
     * $ 顶部活动列表
     */
    const topList = computed(() => {
      const arr = props?.titleBottomInfo?.length ? props.titleBottomInfo.slice(0, 1) : []
      return arr
    })
    /**
     * $ 底部活动列表`
     */
    const bottomList = computed(() => {
      const remainingElements = props?.titleBottomInfo?.length ? props.titleBottomInfo.slice(1) : []
      return remainingElements
    })

    /**
     * $ 顶部活动点击
     */
    const listenTopClick = () => {
      const targetUrl = topList.value[0].url || ''
      targetUrl &&
        skipToUrl({
          targetUrl
        })
    }

    /**
     * $ 活动弹窗显示隐藏 底部活动点击
     */
    const togglePopup = () => {
      showCondition.value = !showCondition.value
    }

    /**
     * $ 活动弹窗点击
     */
    const popupClick = (item) => {
      const targetUrl = item.url || ''
      targetUrl &&
        skipToUrl({
          targetUrl
        })
    }

    return {
      icon,
      listenTopClick,
      titleBottomInfoList,
      topList,
      bottomList,
      showCondition,
      togglePopup,
      popupClick
    }
  }
})
</script>
<style scoped lang="scss">
.process-item {
  width: calc(100% - 24px);
}
.info_text {
  margin-right: 8px;
  padding: 4px 8px;
  color: #111;
  font-size: 20px;
  background: linear-gradient(160deg, #f7deff 0%, #ddfeff 100%);
  border-radius: 10px;
}
.bottom-item {
  .item_address {
    margin-bottom: 0 !important;
  }
}
/deep/ .z-action-picker__content {
  &::-webkit-scrollbar {
    display: none;
  }
}

.params-content {
  // max-height: 66vh;
  padding: 0 32px 80px;
  // overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  .content-list {
    margin-bottom: 68px;
    .item-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      margin-bottom: 20px;
      padding: 40px 32px;
      background: #fafafa;
      border-radius: 16px;
      .item-content-info {
        width: calc(100% - 24px);
        .info-title {
          color: #111;
          font-weight: 500;
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          line-height: 28px;
        }
        .info-desc {
          margin-top: 20px;
          color: #666;
          font-weight: 300;
          font-size: 24px;
          font-family: PingFangSC-Light, PingFang SC;
          line-height: 24px;
        }
      }
      .icon_arrow {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>
